import { useTranslation } from 'next-i18next'
import { useIsMobile } from '../../lib/hooks/useIsMobile'
import { transformHref } from '../overwrites/Link'
import { CurrencyDisplay } from '../common/CurrencyDisplay'

type Props = {
  product: Product
}

export function BookButton({ product }: Props) {
  const { t, i18n } = useTranslation('common')
  const isMobile = useIsMobile()
  const { price, price_other_currencies, product_link, partner } = product

  return (
    <div className="flex flex-col xs:flex-row justify-between gap-4">
      <button
        className="py-2 px-6 flex-1 rounded-lg bg-primary text-white hover:bg-white hover:text-primary transition-colors border border-primary border-2 text-xl flex items-center justify-center gap-4 xs:mb-0 uppercase"
        onClick={() => {
          const section = document.getElementById('check-availability')
          if (
            (isMobile && section) ||
            !product_link ||
            partner === 'regiondo'
          ) {
            section?.scrollIntoView({ behavior: 'smooth' })
          } else {
            window.open(
              transformHref(product_link, i18n.language as any),
              '_blank',
            )
          }
        }}
        aria-label={`${t('book-from')} ${price?.value || ''}`}
      >
        <span className="fas fa-badge-check" />
        <span>
          {t('book-from')}{' '}
          <CurrencyDisplay
            price={price}
            price_other_currencies={price_other_currencies}
            showFrom={false}
          />
        </span>
      </button>
    </div>
  )
}
